import React, { useContext } from "react";
import { useRef } from "react";
import { useAppSelector } from "../../../../../../store/index.ts";
import { useInterval } from "usehooks-ts";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import JanusState from "../../../../../../controls/janus/site/JanusState.js";
import { setLoadingBroadcaster } from "../../../../../../store/chatSlice.js";
import { ENUM_READY_STATE } from "../../../../../../store/enums.js";
import { CanvasContextRef, VideoContextRef } from "../../../../../../pages/CurrentModel.jsx";
import useStreamStatus from "../../../../../../hooks/site/useStreamStatus.js";
import { getPositionParam } from "../../../../../../utils/utils.js";

const COUNT_NO_CAMERA = 1;

export default function VideoDraw() {
  const videoRef = useContext(VideoContextRef);
  const canvasRef = useContext(CanvasContextRef);
  const loadingBroadcaster = useAppSelector((state) => state.chat.loadingBroadcaster);

  const { isStream } = useStreamStatus();

  const dispatch = useDispatch();
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);

  const animationFrameId = useRef(null);
  const countNoCameraRef = useRef(0);

  const videoStyle = { minHeight: isMobile ? "230px" : "350px" };

  // checkNoCamera - проверка есть ли поток с камеры
  const checkNoCamera = () => {
    if (!videoRef.current) return;
    if (!isStream) return;
    const isLive = JanusState.readyState === ENUM_READY_STATE.live;

    const paused = videoRef.current?.paused;
    paused ? countNoCameraRef.current++ : (countNoCameraRef.current = 0);
    if (!paused && isLive) onVideoLoaded();

    if (countNoCameraRef.current >= COUNT_NO_CAMERA && !loadingBroadcaster) {
      console.log("setLoadingBroadcaster true");

      dispatch(setLoadingBroadcaster(true));
      JanusState.isPlayVideo = false;
      countNoCameraRef.current = 0;
    }
  };

  function renderFrame() {
    drawCenteredVideo(videoRef, canvasRef);
    animationFrameId.current = requestAnimationFrame(renderFrame);
  }

  // Функция для отрисовки видео
  function drawCenteredVideo(videoRef, canvasRef) {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    // Проверка, что канвас и видео существуют
    if (!canvas || !video) {
      console.log("Canvas or video element is not available");
      return;
    }

    const ctx = canvas.getContext("2d");
    // Устанавливаем размеры canvas равными его видимым размерам
    const { x, y, width, height } = getPositionParam(canvas, video);

    // Очищаем canvas и рисуем видео
    ctx.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
    ctx.drawImage(video, x, y, width, height);
  }

  const onVideoPlay = () => {
    console.log("onVideoPlay");
    checkNoCamera();

    // Останавливаем старые циклы перед началом нового
    if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);

    renderFrame();
  };

  const onVideoLoaded = () => {
    if (loadingBroadcaster) {
      console.log("setLoadingBroadcaster false");
      dispatch(setLoadingBroadcaster(false));
    }
    JanusState.isPlayVideo = false;
  };

  useEffect(() => {
    if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);

    return () => {
      // Очистка при размонтировании компонента
      if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
    };
  }, []);

  useInterval(() => {
    checkNoCamera();
  }, 3_000);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      className="broadcaster-video"
      style={videoStyle}
      onPlay={onVideoPlay}
      onPause={checkNoCamera}
      // onLoadedData={onVideoLoaded}
      controls={false}
    />
  );
}
